import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import Image from 'next/image';
import { FaUserCircle, FaBars, FaTimes, FaChevronRight } from "react-icons/fa";
import { auth } from '../utils/firebaseConfig';
import { onAuthStateChanged, signOut } from "firebase/auth";

const Header = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const router = useRouter();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                setIsLoggedIn(true);
            } else {
                setIsLoggedIn(false);
            }
        });

        // Clean up subscription on unmount
        return () => unsubscribe();
    }, []);

    const handleLogout = async () => {
        try {
            await signOut(auth);
            router.push('/');
        } catch (error) {
            console.error('Error signing out: ', error);
        }
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    return (
        <header className="bg-white text-gray-900 p-4 shadow-md relative">
            <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:p-4 focus:bg-blue-600 focus:text-white">
                Zum Hauptinhalt springen
            </a>
            <div className="container mx-auto flex justify-between items-center">
                <div className="flex items-center">
                    <Image src="/images/logo.png" alt="Logo" width={40} height={40} />
                    <div className="text-xl font-bold ml-2">
                        <Link href="/">10-finger-schreiben-lernen.de</Link>
                    </div>
                </div>
                <div className="md:hidden">
                    <button 
                        onClick={toggleMenu} 
                        aria-label={isMenuOpen ? "Menü schließen" : "Menü öffnen"}
                        aria-expanded={isMenuOpen}
                        className="p-2"
                    >
                        {isMenuOpen ? <FaTimes className="w-6 h-6" /> : <FaBars className="w-6 h-6" />}
                    </button>
                </div>
                <nav className="hidden md:flex space-x-4" aria-label="Hauptnavigation">
                    <Link href="/tipptest" className="hover:text-gray-600 py-1 px-2">Tipp-Test</Link>
                    <Link href="/einfuehrung" className="hover:text-gray-600 py-1 px-2">Einführung</Link>
                    <Link href="/leitfaden" className="hover:text-gray-600 py-1 px-2">Leitfaden</Link>
                    <Link href="/uebungen" className="hover:text-gray-600 py-1 px-2">Übungen</Link>
                    <Link href="/statistik" className="hover:text-gray-600 py-1 px-2">Statistik</Link>
                    {isLoggedIn && (
                        <Link href="/leaderboard" className="hover:text-gray-600 py-1 px-2">Bestenliste</Link>
                    )}
                    <Link href="/pro" className="hover:text-gray-600 py-1 px-2">Pro-Version</Link>
                    <Link href="/blog" className="hover:text-gray-600 py-1 px-2">Blog</Link>
                    {!isLoggedIn ? (
                        <>
                            <Link href="/register" className="hover:text-gray-600 py-1 px-2">Register</Link>
                            <Link href="/login" className="hover:text-gray-600 py-1 px-2">Login</Link>
                        </>
                    ) : (
                        <Link href="/profile" className="hover:text-gray-600 py-1 px-2" aria-label="Benutzerprofil öffnen">
                            <FaUserCircle className="inline-block w-6 h-6" aria-hidden="true" />
                        </Link>
                    )}
                </nav>
            </div>
            {isMenuOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50" onClick={closeMenu}>
                    <div className="fixed top-0 left-0 w-full bg-white shadow-lg h-full z-50 p-4 overflow-y-auto transform translate-x-0 transition-transform duration-300" onClick={(e) => e.stopPropagation()}>
                        <div className="flex justify-between items-center mb-8">
                            <div className="flex items-center">
                                <Link href="/">
                                    <Image src="/images/logo.png" alt="Logo" width={40} height={40} />
                                </Link>
                            </div>
                            <button onClick={closeMenu} className="">
                                <FaTimes className="w-6 h-6" />
                            </button>
                        </div>
                        <nav className="space-y-3 divide-y">
                            <Link href="/tipptest" onClick={closeMenu} className="flex justify-between items-center py-2 w-full">
                                <span className="block text-lg font-medium">Tipp-Test</span>
                                <FaChevronRight />
                            </Link>
                            <Link href="/einfuehrung" onClick={closeMenu} className="flex justify-between items-center py-2 w-full">
                                <span className="block text-lg font-medium">Einführung</span>
                                <FaChevronRight />
                            </Link>
                            <Link href="/leitfaden" onClick={closeMenu} className="flex justify-between items-center py-2 w-full">
                                <span className="block text-lg font-medium">Leitfaden</span>
                                <FaChevronRight />
                            </Link>
                            <Link href="/uebungen" onClick={closeMenu} className="flex justify-between items-center py-2 w-full">
                                <span className="block text-lg font-medium">Übungen</span>
                                <FaChevronRight />
                            </Link>
                            <Link href="/statistik" onClick={closeMenu} className="flex justify-between items-center py-2 w-full">
                                <span className="block text-lg font-medium">Statistik</span>
                                <FaChevronRight />
                            </Link>
                            {isLoggedIn && (
                                <Link href="/leaderboard" onClick={closeMenu} className="flex justify-between items-center py-2 w-full">
                                    <span className="block text-lg font-medium">Bestenliste</span>
                                    <FaChevronRight />
                                </Link>
                            )}
                            <Link href="/pro" onClick={closeMenu} className="flex justify-between items-center py-2 w-full">
                                <span className="block text-lg font-medium">Pro-Version</span>
                                <FaChevronRight />
                            </Link>
                            <Link href="/blog" onClick={closeMenu} className="flex justify-between items-center py-2 w-full">
                                <span className="block text-lg font-medium">Blog</span>
                                <FaChevronRight />
                            </Link>
                        </nav>
                        {!isLoggedIn && (
                            <div className="mt-8 flex flex-col items-center space-y-2 w-full px-4">
                                <Link href="/register" className="w-full" onClick={closeMenu}>
                                    <button className="bg-gray-800 text-white py-2 rounded hover:bg-gray-900 transition duration-300 w-full">Registrieren</button>
                                </Link>
                                <Link href="/login" className="w-full" onClick={closeMenu}>
                                    <button className="bg-white border border-gray-400 text-black py-2 rounded transition hover:bg-gray-100 duration-300 w-full">Anmelden</button>
                                </Link>
                            </div>
                        )}
                        {isLoggedIn ? (
                            <div className="mt-8 flex flex-col items-center space-y-2 w-full px-4">
                                <Link href="/profile" onClick={closeMenu} className="flex justify-between items-center py-2 w-full">
                                    <span className="flex items-center text-lg font-medium">
                                        <FaUserCircle className="inline-block w-6 h-6 mr-2" /> Profil
                                    </span>
                                    <FaChevronRight />
                                </Link>
                            </div>
                        ) : null}
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
